import React from 'react'
import PropTypes from 'prop-types'
import convert from 'htmr'
import Bulb from 'media/bulb.svg?svgr-webpack'
import cn from 'classnames'

export default function AsideBlock({
  symbol,
  heading = 'Did you know…?',
  text,
}) {
  return (
    <aside
      className={cn(`
      float-right
      mb-24 ml-32
      mt-4 w-1/2 border-l-1
      border-dotted border-Border pl-16 md:w-2/5 lg:ml-48 lg:pl-24
      xl:pl-32 xxl:-mr-1/2 xxl:ml-0
    `)}
    >
      {symbol?.url ? (
        <img src={symbol.url} alt="" style={{ width: 40 }} />
      ) : (
        <Bulb className="-mt-12 origin-bottom-left scale-75 transform" />
      )}
      <h2 className="type-upper-fat mb-12 mt-6 text-grey md:mb-16">
        {heading}
      </h2>
      <p className="type-small leading-body">{convert(text)}</p>
    </aside>
  )
}

AsideBlock.propTypes = {
  symbol: PropTypes.object,
  heading: PropTypes.string,
  text: PropTypes.string,
}
